import axios from "@/plugins/axios";

let url = "/api/v1/terms";

export default {
    getTermsAll(data){
        return axios.get(url, data).then(result => result.data);
    },
    getTerms(data){
        return axios.get(`${url}/${data.code}`).then(result => result.data);
    },
}
